module.exports = __webpack_public_path__ + "img/pro_thirteen_3.43eceff3.jpg";